var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { "data-vv-scope": "otp-form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.activateSign($event)
        }
      }
    },
    [
      _vm.signConfiguration.urlResponsavilidad
        ? _c(
            "div",
            { staticClass: "container-pdf" },
            _vm._l(_vm.numPages, function(p, index) {
              return _c("pdf", {
                key: p + "-" + index,
                staticClass: "m-auto",
                attrs: {
                  page: p,
                  src: _vm.signConfiguration.urlResponsavilidad
                }
              })
            }),
            1
          )
        : _vm._e(),
      _c("label", [_vm._v("Código OTP")]),
      _c("b-form-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|digits:6",
            expression: "'required|digits:6'"
          }
        ],
        attrs: {
          id: "otp_input",
          name: "otp_input",
          "data-vv-as": "otp",
          state: !this.errors.has("otp-form.otp_input"),
          placeholder: "Ingrese los 6 dígitos de Google Authenticator"
        },
        model: {
          value: _vm.otp,
          callback: function($$v) {
            _vm.otp = $$v
          },
          expression: "otp"
        }
      }),
      _c("FormError", {
        attrs: { attributeName: "otp-form.otp_input", errorsForm: _vm.errors }
      }),
      _c(
        "div",
        { staticClass: "text-center mt-4" },
        [
          _c(
            "b-button",
            {
              attrs: {
                title: _vm.otp ? "Activar" : "Ingrese 6 dígitos",
                disabled: _vm.loading || !_vm.otp,
                variant: "primary"
              },
              on: { click: _vm.activateSign }
            },
            [_vm._v(" " + _vm._s(_vm.getBtnText()) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }